var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrustpilotReviewsScraper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.44048,
    y1: 0.88619,
    x2: 81.05694,
    y2: 83.47983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#93f9ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27768,
    stopColor: "#42e7b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48883,
    stopColor: "#03da8d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#036d61"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M78.17747,88.61091c-18.78499,2.12302-37.56996,2.12302-56.35494,0-5.49081-.62055-9.8129-4.94264-10.43345-10.43345-2.12301-18.78497-2.12301-37.56995,0-56.35493.62055-5.49081,4.94265-9.8129,10.43346-10.43345,18.78498-2.12301,37.56995-2.12301,56.35494,0,5.49081.62055,9.8129,4.94264,10.43346,10.43345,2.12301,18.78497,2.12301,37.56995,0,56.35492-.62055,5.49081-4.94265,9.8129-10.43345,10.43345Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "50 62.51396 65.40562 73.70679 60.64502 59.05518 50 62.51396"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.02227,35.86712l-4.46303-.89189-2.2274-3.96909c-.48671-.86713-1.73495-.86713-2.22156,0l-2.2274,3.96909-4.46303.89189c-.97511.19486-1.36087,1.38197-.68653,2.11278l3.08651,3.34487-.53099,4.52019c-.11601.98759.89387,1.72137,1.79726,1.30579l4.13492-1.90177,4.13502,1.90177c.90338.41558,1.91317-.3182,1.79716-1.30579l-.5309-4.52019,3.08651-3.34487c.67434-.73081.28858-1.91792-.68653-2.11278Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.28882,45.84497c-.09326.79425.54175,1.42444,1.26385,1.42444.17578,0,.35663-.03729.53345-.11865l4.13489-1.90179,4.13501,1.90179c.17676.0813.35773.11865.53339.11865.72217,0,1.35712-.63013,1.26379-1.42444l-.16931-1.44141h-11.52576l-.16931,1.44141Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.88446,44.40356l-5.88446-18.11035-2.66479,8.20142c.18018.31311.33905.64069.45312.99182.58856,1.8114.15186,3.80621-1.13983,5.20605l-1.83893,1.99286.31635,2.69299c.17554,1.49469-.2959,2.99524-1.29346,4.11682-1.00281,1.12756-2.44,1.77423-3.94305,1.77423-.76404,0-1.50592-.16309-2.20477-.48456l-2.46362-1.13312-1.79071.82361,7.04852,5.12109-5.8844,18.11035,15.40558-11.19281,9.52124-6.91754,15.40558-11.19287h-19.04236Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustpilotReviewsScraper);
export default __webpack_public_path__ + "static/media/trustpilot-reviews-scraper.5a1bf99a5a69d0697745a066625ebfde.svg";
export { ForwardRef as ReactComponent };